import { Send, Visibility } from '@mui/icons-material';

import { Flex } from 'src/components/Flex';

interface CallToActionsProps {
    onView: () => void;
}

function CallToActions({ onView }: CallToActionsProps) {
    const actionStyle = {
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        bgcolor: '#F39E4E',
        borderRadius: '4px',
        padding: '8px',
        cursor: 'pointer',
    };
    return (
        <Flex gap="6px">
            <Flex sx={actionStyle} onClick={onView} role="button" aria-label="View details">
                <Visibility height="24px" width="24px" />
            </Flex>
            <Flex sx={actionStyle} aria-label="Resend statement">
                <Send height="24px" width="24px" />
            </Flex>
        </Flex>
    );
}

export default CallToActions;
